export default __webpack_public_path__ + "static/media/once.be05556b.svg";